import { Spin } from 'antd'
import './FacilityBuildingTabs.less'
import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'
import useStore from '@/hooks/useStore'

function FacilityBuildingTabs() {
  const facilityStore = useStore('facilityStore')
  const [resultShow, setResultShow] = useState(true)
  const [Loading, setLoading] = useState(false)
  const [liArr, setLiArr] = useState<any>([])
  useEffect(() => {
    setLoading(true)
    setLiArr([])
    facilityStore.queryFacilityInfo().then((res: any) => {
      if (res.code === 200) {
        const arr: any = []
        if (res.result.length > 0) {
          // eslint-disable-next-line array-callback-return
          res.result.map((item: any) => {
            arr.push(item)
          })
          setLiArr(arr)
        }
        setLoading(false)
      }
      else {
        setLoading(false)
        setResultShow(true)
      }
    })
  }, [facilityStore.FacilityLeaseInfo])

  return (
        <div className={'FacilityBuildingTabs'}>
            {
                resultShow
                  ? (
                        <Spin tip="검색..." size="large" spinning={Loading}>
                            <div className={'building-inner'}>
                                <div className={'tbl-wrap'}>
                                  <div className={'tbl-wrap-title'}>
                                    <strong>주요시설</strong>
                                    <a>가장 가까운 곳(최대 10km)</a>
                                    </div>
                                    <div className={'building-box'}>
                                        <ul className={'building-list'}>
                                          {
                                            liArr.map((item: any) => (
                                                <li className={item.fcltType}>
                                                  <a>
                                                    <p>{item.nm}</p>
                                                    <span>{Math.floor(item.distance).toLocaleString()}m</span>
                                                  </a>
                                                </li>
                                            ),
                                            )
                                          }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </Spin>
                    )
                  : (
                        <div className={'not-info'}>
                              결과가 없습니다.
                        </div>
                    )
            }

        </div>
  )
}
export default observer(FacilityBuildingTabs)
